import { Outlet } from 'react-router-dom';

function ManageCompanyBasePage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default ManageCompanyBasePage;
